export default "__VITE_ASSET__DvKZ8Vgb__"